export default class {
    constructor(el) {
        this.filmId = el.getAttribute('data-embeds-filmId');
        this.trailerId = el.getAttribute('data-embeds-trailerClipboard');
        this.seriesId = el.getAttribute('data-embed-seriesId');

        this._insertEmbed(this.filmId);
    }

    _showDropdown(e) {
        document.querySelector('.embedsDropdown').classList.toggle('as-none');
    }

    copyStringToClipboard(str, msg) {
        let el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style = {position: 'absolute', left: '-9999px'};

        document.body.appendChild(el);

        el.select();

        document.execCommand('copy');
        document.body.removeChild(el);

        alert(msg);
    }

    _inserSeriesToClipBoad() {
        let thanks = 'Код для вставки сериала успешно скопирован.';

        this.copyStringToClipboard(
            `<iframe border="0" frameborder="0" height="300" id="ka-embed-${this.seriesId}" src="https://api.kinoafisha.info/embed/series/${this.seriesId}" width="100%"></iframe><script type="text/javascript" src="https://api.kinoafisha.info/embed.js"></script>`,
            thanks);
    }

    _insertTrailerToClipboard() {
        let thanks = 'Код для вставки трейлера успешно скопирован.';

        this.copyStringToClipboard(
            `<iframe title="Kinoafisha player" width="100%" height="296" src="https://api.kinoafisha.info/player/embed/${this.trailerId}" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" allowfullscreen></iframe>`,
            thanks);
    }

    _insertFilmCardToClipboard() {
        let thanks = 'Код для вставки карточки фильма успешно скопирован.';
        this.copyStringToClipboard(
            `<iframe border="0" frameborder="0" height="300" id="ka-embed-${this.filmId}" src="https://api.kinoafisha.info/embed/movie/${this.filmId}/" width="100%"></iframe><script type="text/javascript" src="https://api.kinoafisha.info/embed.js"></script>`,
            thanks
        );
    }

    _createDropDownItems(dropdown) {
        let texts = [];
        let that = this;

        if (this.filmId) {
            texts.push('Код для вставки карточки фильма')
        }

        if (this.trailerId) {
            texts.push('Код для вставки карточки трейлера');
        }

        if (this.seriesId) {
            texts.push('Код для вставки карточки сериала');
        }

        texts.forEach((txt, ind) => {
            let item = document.createElement('div');
            item.classList.add('embedsDropdown_item');
            item.setAttribute('data-emdedsDropdownItem', '');
            let icon = document.createElement('div');
            icon.classList.add('embedsDropdown_icon');

            if (txt.indexOf('трейлера') >= 0) {
                icon.classList.add('embedsDropdown_icon-trailer');
            }
            if (txt.indexOf('фильма') >= 0 || txt.indexOf('сериала') >= 0 ) {
                icon.classList.add('embedsDropdown_icon-film');
            }

            item.appendChild(icon);
            let text = document.createElement('span');
            text.classList.add('embedsDropdown_text');
            text.innerText = txt;
            item.appendChild(text);

            dropdown.appendChild(item);

            item.addEventListener('click', function (e) {
                let filmTest = e.currentTarget.querySelector('.embedsDropdown_icon-film');
                let trailerTest = e.currentTarget.querySelector('.embedsDropdown_icon-trailer');

                if (that.filmId && filmTest ) {
                    that._insertFilmCardToClipboard()
                }

                if (that.seriesId && filmTest ) {
                    that._inserSeriesToClipBoad()
                }

                if (that.trailerId && trailerTest) {
                    that._insertTrailerToClipboard()
                }
            })
        })
    }

    _createDropdown(button) {
        let div = document.createElement('div');
        div.classList.add('embedsDropdown');
        div.classList.add('as-none');
        let wrap = document.createElement('div');
        wrap.classList.add('embedsDropdown_wrap');
        this._createDropDownItems(wrap);
        div.appendChild(wrap);

        button.appendChild(div);
    }

    _insertEmbed() {
        let that = this;

        const div = document.createElement('div');
        div.classList.add('ya-share2__item_service_embed');

        const img = document.createElement('div');
        img.classList.add('ya-share2__item_service_embed-image');

        const dest = document.querySelector('.yaShareWrapper-stretch');

        dest.appendChild(div);
        div.appendChild(img);

        div.addEventListener('click', function (e) {
            if (e.target === e.currentTarget || e.target.classList.value.indexOf(e.currentTarget.classList.value) >= 0) {
                that._showDropdown(e);
            }
        });

        this._createDropdown(div);
    }
}